import { ErrorsOr } from "./error.monad";
import { Validator } from "@me8eon/validate";

export type ParseJsonConfig<T> = {
    mustBeObject?: true,
    validate?: Validator<T>
    isA?: (json: any) => json is T
}
export const parseJson = <T>(context: string, config: ParseJsonConfig<T> = {}) => (s: string): ErrorsOr<T> => {
    try {
        const { mustBeObject, validate, isA } = config;
        const json = JSON.parse(s);
        if (mustBeObject && typeof json !== "object") return { errors: [`${context} must be an object, but got ${typeof json}. String was ${s}`] };
        if (validate) {
            const errors = validate(context)(json);
            if (errors.length > 0) return { errors: errors, extras: s };
        }
        if (isA && !isA(json)) return { errors: [`${context} is not of the expected type. ${s}`] };
        return { value: json };
    } catch (e: any) {
        return { errors: [`Failed to parse ${context} as JSON: ${e.message}`], extras: e };
    }
};